import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'upsellDisplayLimit',
  initialState: 3,
  reducers: {
    setUpsellDisplayLimit(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setUpsellDisplayLimit } = slice.actions;
export default slice.reducer;
